import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router';

import { EmptyState } from '../components/EmptyState';
import { ErrorMessage } from '../components/ErrorMessage';
import { PageLoader } from '../components/Loader';
import { projectKeys, useProjectApi } from '../projects/useProjectApi';
import { useProject } from '../projects/context';
import { addDays, appointmentStatusLabels, fmtDateTime, fromLocal, localDate } from './format';

// Termine der nächsten 60 Tage ohne zugewiesenen Makler (Posteingang und Termine).
export function UnassignedAppointments({ areaId }: { areaId?: string }) {
  const { project } = useProject();
  const papi = useProjectApi();
  const today = localDate();
  const q = { from: fromLocal(today, '00:00'), to: fromLocal(addDays(today, 60), '00:00'), area_id: areaId, unassigned: 'true' as const };
  const list = useQuery({ queryKey: projectKeys.calendar(project.id, q), queryFn: ({ signal }) => papi.calendar(q, signal), refetchInterval: 120_000 });
  const items = (list.data?.items ?? []).filter((i) => i.status !== 'CANCELED');

  if (list.isPending) return <PageLoader />;
  if (list.isError) return <ErrorMessage error={list.error} onRetry={() => void list.refetch()} />;
  if (items.length === 0) return <EmptyState title="Alle Termine haben einen Makler" icon="calendar">In den nächsten 60 Tagen ist nichts offen.</EmptyState>;
  return (
    <div className="table-wrap">
      <table className="table">
        <thead>
          <tr>
            <th>Termin</th>
            <th>Lead</th>
            <th>Ort</th>
            <th>Gebiet</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {items.map((a) => (
            <tr key={a.id}>
              <td>
                <Link to={`/p/${project.key}/termine/${a.id}`}>{fmtDateTime(a.start_at)}</Link>
              </td>
              <td>{a.lead_name ?? a.title}</td>
              <td>{[a.city, a.county_name].filter(Boolean).join(' · ') || '–'}</td>
              <td>{a.area_name ?? '–'}</td>
              <td>{appointmentStatusLabels[a.status]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
